/*
 * Copyright (c) 2025. Spin in het Web B.V. Apeldoorn.
 */
import {BaseModule} from "./modules/BaseModule";
export type ImageResizeOptions =
  Partial<
    {
      modules: (string | typeof BaseModule) [];
      overlayStyles: Partial<{
        position: string;
        boxSizing: string;
        border: string;
      }>;
      handleStyles: Partial<{
        position: string;
        height: string;
        width: string;
        backgroundColor: string;
        border: string;
        boxSizing: string;
        opacity: string;
      }>;
      displayStyles: Partial<{
        position: string;
        font:string;
        padding: string;
        textAlign: string;
        backgroundColor: string;
        color: string;
        border: string;
        boxSizing: string;
        opacity: string;
        cursor: string;
      }>;
      toolbarStyles: Partial<{
        position: string;
        top: string;
        right: string;
        left: string;
        height: string;
        minWidth: string;
        font: string;
        textAlign: string;
        color: string;
        boxSizing: string;
        cursor: string;
      }>;
      toolbarButtonStyles:  Partial<{
        display: string;
        width: string;
        height: string;
        background: string;
        border: string;
        verticalAlign: string;
      }>;
      toolbarButtonSvgStyles:  Partial<{
        fill: string;
        stroke: string;
        strokeWidth: string;
      }>;
    }>
export const defaultOptions: ImageResizeOptions = {
  modules: [
    'DisplaySize',
    'Toolbar',
    'Resize',
  ],
  overlayStyles: {
    position: 'absolute',
    boxSizing: 'border-box',
    border: '1px dashed #444',
  },
  handleStyles: {
    position: 'absolute',
    height: '12px',
    width: '12px',
    backgroundColor: 'white',
    border: '1px solid #777',
    boxSizing: 'border-box',
    opacity: '0.80',
  },
  displayStyles: {
    position: 'absolute',
    font: '12px/1.0 Arial, Helvetica, sans-serif',
    padding: '4px 8px',
    textAlign: 'center',
    backgroundColor: 'white',
    color: '#333',
    border: '1px solid #777',
    boxSizing: 'border-box',
    opacity: '0.80',
    cursor: 'default',
  },
  toolbarStyles: {
    position: 'absolute',
    top: '-12px',
    right: '0',
    left: '0',
    height: '0',
    minWidth: '100px',
    font: '12px/1.0 Arial, Helvetica, sans-serif',
    textAlign: 'center',
    color: '#333',
    boxSizing: 'border-box',
    cursor: 'default',
  },
  toolbarButtonStyles: {
    display: 'inline-block',
    width: '24px',
    height: '24px',
    background: 'white',
    border: '1px solid #999',
    verticalAlign: 'middle',
  },
  toolbarButtonSvgStyles: {
    fill: '#444',
    stroke: '#444',
    strokeWidth: '2',
  },
};
